import { render, staticRenderFns } from "./AnnualReturnsActivity.vue?vue&type=template&id=391b62c4&scoped=true&"
import script from "./AnnualReturnsActivity.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b62c4",
  null
  
)

export default component.exports